import { Logo } from '@bbr/brand/logo';
import { Link } from '@bbr/ui';
import { createAsync } from '@solidjs/router';
import { createMemo } from 'solid-js';
import { Footer } from '#components/footer.tsx';
import { requireLoggedOut } from '../providers/user.tsx';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

export default function LoginRoute(props: RouteSectionProps) {
	const redirectPath = createMemo(() => getRedirectPath(props.location.query.redirect));

	createAsync(async () => (redirectPath ? requireLoggedOut(redirectPath()) : null), {
		deferStream: true,
	});

	return (
		<>
			<div class="mx-auto flex min-h-dvh max-w-xl grow items-center justify-center">
				<div class="flex min-w-sm flex-col items-center gap-6">
					<Link href="/" class="flex items-center gap-2 text-lg font-bold hover:text-yellow-600">
						<Logo />
					</Link>
					<main class="w-full max-w-sm rounded-lg border-zinc-200 p-4 sm:border dark:border-zinc-800">
						{props.children}
					</main>
				</div>
			</div>
			<Footer />
		</>
	);
}

export const route = {
	preload: async ({ location }) => {
		const redirectPath = getRedirectPath(location.query.redirect);
		return await requireLoggedOut(redirectPath);
	},
} satisfies RouteDefinition;

function getRedirectPath(input?: string | Array<string>) {
	const redirectPath = Array.isArray(input) ? input[0] : input;
	if (typeof redirectPath === 'string') {
		try {
			return redirectPath.startsWith('http') ? new URL(redirectPath).pathname : redirectPath;
		} catch {
			// okay
		}
	}

	return '/';
}
